import React from 'react';

export default function iconhelp() {
  useEffect(() => {
    document.title = 'TheraMe - iconhelp';
  }, []);
  return (
    <div className="container-fluid px-0">
      <div className="container-fluid  py-3" style={{ backgroundColor: 'rgb(51, 178, 234)' }}>
        <h2 className="text-white">Emotions and Their Definitions</h2>
      </div>
      <div className="container-fluid py-5">
        <div className="row g-4">
          <div className="col-lg-4">
            <div className="card h-100 shadow-sm">
              <div className="card-body">
                <h5 className="card-title" style={{ color: 'rgb(255, 0, 255)' }}>
                  Love
                </h5>
                <p className="card-text">
                  <strong>Definition: </strong>
                  An emotion characterized by strong feelings of affection for another arising out
                  of kinship, companionship, admiration, or benevolence.
                </p>
              </div>
            </div>
          </div>
          <div className="col-lg-4">
            <div className="card h-100 shadow-sm">
              <div className="card-body">
                <h5 className="card-title" style={{ color: 'rgb(166, 0, 255)' }}>
                  Gratitude
                </h5>
                <p className="card-text">
                  <strong>Definition: </strong>A feeling of thankfulness or appreciation for someone
                  or something in your life, often accompanied by feelings of warmth, kindness, and
                  a desire to reciprocate.
                </p>
              </div>
            </div>
          </div>
          <div className="col-lg-4">
            <div className="card h-100 shadow-sm">
              <div className="card-body">
                <h5 className="card-title" style={{ color: 'rgb(251, 198, 31)' }}>
                  Joy
                </h5>
                <p className="card-text">
                  <strong>Definition: </strong>The state of being that allows one to experience
                  feelings of intense, long-lasting happiness and contentment of life.
                </p>
              </div>
            </div>
          </div>
          <div className="col-lg-4">
            <div className="card h-100 shadow-sm">
              <div className="card-body">
                <h5 className="card-title" style={{ color: 'rgb(157, 59, 108)' }}>
                  Pride
                </h5>
                <p className="card-text">
                  <strong>Definition: </strong>A feeling of satisfaction and accomplishment in
                  oneself, one's abilities, or the accomplishments of others. Pride can be positive,
                  motivating, and empowering, but also lead to arrogance if not balanced with
                  humility.
                </p>
              </div>
            </div>
          </div>
          <div className="col-lg-4">
            <div className="card h-100 shadow-sm">
              <div className="card-body">
                <h5 className="card-title" style={{ color: 'rgb(0, 137, 177)' }}>
                  Surprise
                </h5>
                <p className="card-text">
                  <strong>Definition: </strong>A sudden and unexpected feeling caused by something
                  unusual happening.
                </p>
              </div>
            </div>
          </div>
          <div className="col-lg-4">
            <div className="card h-100 shadow-sm">
              <div className="card-body">
                <h5 className="card-title" style={{ color: 'rgb(134, 190, 101)' }}>
                  Disgust
                </h5>
                <p className="card-text">
                  <strong>Definition: </strong>A strong feeling of revulsion or aversion towards
                  something offensive. It can be triggered by smells, tastes, sounds, sights, touch,
                  people’s actions or appearances, and ideas.
                </p>
              </div>
            </div>
          </div>
          <div className="col-lg-4">
            <div className="card h-100 shadow-sm">
              <div className="card-body">
                <h5 className="card-title" style={{ color: 'rgb(109, 158, 246)' }}>
                  Sadness
                </h5>
                <p className="card-text">
                  <strong>Definition: </strong>A natural human emotion characterized by sorrow,
                  disappointment, and despair, often triggered by loss, rejection, failure, or unmet
                  emotional needs.
                </p>
              </div>
            </div>
          </div>
          <div className="col-lg-4">
            <div className="card h-100 shadow-sm">
              <div className="card-body">
                <h5 className="card-title" style={{ color: 'rgb(253, 79, 83)' }}>
                  Anger
                </h5>
                <p className="card-text">
                  <strong>Definition: </strong>A normal emotional response to feeling unfairly
                  treated or harmed. It often arises when feeling emotionally, physically, or
                  financially threatened.
                </p>
              </div>
            </div>
          </div>
          <div className="col-lg-4">
            <div className="card h-100 shadow-sm">
              <div className="card-body">
                <h5 className="card-title" style={{ color: 'rgb(255, 143, 0)' }}>
                  Fear
                </h5>
                <p className="card-text">
                  <strong>Definition: </strong>An emotion arising when a threat or danger is
                  perceived, causing physiological and psychological changes. It triggers a
                  "fight-or-flight" response and serves as a protective mechanism.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <footer
        className="border border-bottom-0 border-start-0 border-end-0 py-2"
        style={{ color: 'rgb(18, 56, 104)' }}
      >
        <div className="text-center">
          <span className="fw-bold">2025 The Tea Group. All Rights Reserved.</span>
        </div>
      </footer>
    </div>
  );
}
